<div class="d-flex pt-3 pb-3 justify-content-end inline-gap-10">
  <button class="tu-button secondary tu-shadow" (click)="pdf()">{{ 'content.pdf-download' | translate }}</button>
  <button class="tu-button primary tu-shadow" [routerLink]="newOrderUrl">{{ 'content.new-order' | translate }}</button>
</div>
